import { useSectionContent } from "./useSectionContent";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Activity, TreePine, MapPin, BookOpen, Sparkles, Users, ShieldCheck, Wind } from "lucide-react";
import api from "@/lib/api";
import CountUp from "@/components/motion/CountUp";
import { useSite } from "@/contexts/SiteContext";
import { useAuth } from "@/contexts/AuthContext";


/* Secțiuni noi de homepage (Dim 15). Fiecare e o secțiune CMS (visible din live editor). */


/* ── 15.27 Micro-demonstrație a metodei (respirație 60s) ── */
export function HomeMiniDemo() {
  const c = useSectionContent("home_mini_demo");
  const [phase, setPhase] = useState("gata");
  const [running, setRunning] = useState(false);
  useEffect(() => {
    if (!running) return;
    const seq = [["Inspiră...", 4000], ["Ține...", 4000], ["Expiră lung...", 6000]];
    let i = 0; let t;
    const tick = () => { setPhase(seq[i][0]); const d = seq[i][1]; i = (i + 1) % seq.length; t = setTimeout(tick, d); };
    tick();
    return () => clearTimeout(t);
  }, [running]);
  return (
    <section className="py-16 lg:py-20" style={{ background: "var(--ct-bg)" }}>
      <div className="max-w-xl mx-auto px-5 text-center">
        <span data-el="eyebrow" data-field="eyebrow" className="eyebrow">{c.eyebrow || "Simte diferența în 60 de secunde"}</span>
        <h2 data-el="title" data-field="title" className="font-serif text-3xl sm:text-4xl mt-3 mb-6">{c.title || "Un minut doar pentru tine, chiar acum"}</h2>
        <div className="flex items-center justify-center mb-6" style={{ height: 180 }}>
          <div style={{
            width: 110, height: 110, borderRadius: "50%",
            background: "radial-gradient(circle at 50% 45%, var(--ct-cream-edge), transparent 70%)",
            border: "2px solid var(--ct-emerald)",
            transform: running && phase === "Expiră lung..." ? "scale(0.7)" : running ? "scale(1.3)" : "scale(1)",
            transition: `transform ${phase === "Expiră lung..." ? 6 : 4}s ease-in-out`,
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <span className="text-xs" aria-live="polite" aria-atomic="true" style={{ color: "var(--ct-link)" }}>{running ? phase : "gata?"}</span>
          </div>
        </div>
        <button data-el="cta" type="button" onClick={() => setRunning((r) => !r)} className="btn-gold" data-testid="home-minidemo">
          <Wind size={15} /> {running ? "Oprește" : (<span data-field="cta">{c.cta || "Respiră cu mine 1 minut"}</span>)}
        </button>
        {/* Text și link separate: editarea inline a textului nu mai poate șterge punte-a către /programare */}
        <p data-el="body" className="text-sm mt-5" style={{ color: "var(--ct-text-muted)" }}>
          <span data-field="body">{c.body || "Ai simțit? O ședință merge mult mai adânc de-atât."}</span>{" "}
          <Link to={c.body_cta_link || "/programare"} style={{ color: "var(--ct-link)" }}><span data-field="body_cta">{c.body_cta || "Hai să vorbim →"}</span></Link>
        </p>
      </div>
    </section>
  );
}
